module.exports = __webpack_public_path__ + "static/media/JustAct Icons 2 _V2-03.4ffffe08.svg";